import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=398655ad"
import script from "./AddressEdit.ts?vue&type=script&lang=ts&external"
export * from "./AddressEdit.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports